export default __webpack_public_path__ + "static/media/moonba.26dda1f8.svg";